































































import { Company } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'

@Component
export default class UpsertCompanyModal extends Vue {
  @Prop({ required: false }) company: Company

  private companySave: Company = {
    id: '',
    name: '',
    createdOn: '',
    updatedOn: ''
  }

  @Watch('company', { deep: true })
  onCompanyChanged() {
    this.updateCompany()
  }

  get newCompany(): boolean {
    return this.company == null || !this.company.id
  }

  private updateCompany() {
    if (this.company && this.company.id) {
      Vue.set(this.companySave, 'id', this.company.id)
      Vue.set(this.companySave, 'name', this.company.name)
    } else {
      this.clearForm()
    }
  }

  private formOk(): boolean {
    return !!this.companySave.id && !!this.companySave.name
  }

  hideModal() {
    this.$bvModal.hide('UpsertCompanyModal')
  }

  private saveForm(): void {
    if (!this.formOk()) {
      alert('Form not valid!')
      return
    }
    const promise = this.newCompany
      ? ApiClient.createCompany(this.companySave)
      : ApiClient.updateCompany(this.companySave.id, this.companySave)

    promise
      .then((companySaved: Company) => {
        this.$emit('companySaved', companySaved)
        this.hideModal()
        this.clearForm()
      })
      .catch((ex: Error) => alert(`Error: ${ex.message}`))
  }

  private clearForm() {
    Vue.set(this.companySave, 'id', '')
    Vue.set(this.companySave, 'name', '')
  }
}
